import { Component, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Report from "@/pages/Report";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <p className="text-sm text-[#8a8a9e]">
            Si è verificato un errore.{" "}
            <button
              onClick={() => window.location.reload()}
              style={{ color: "#ff007f", textDecoration: "underline", background: "none", border: "none", cursor: "pointer" }}
            >
              Ricarica
            </button>
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

function SmoothScroll() {
  const { pathname } = useLocation();
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1 });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    lenis.scrollTo(0, { immediate: true });
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <SmoothScroll />
        <div className="relative min-h-screen">
          <div className="grid-bg" aria-hidden="true" />
          <Header />
          <main className="relative z-10">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/report/:targa" element={<Report />} />
            </Routes>
          </main>
          <Footer />
        </div>
        <Toaster theme="dark" position="top-center" />
      </BrowserRouter>
    </ErrorBoundary>
  );
}
